module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "echart_trend"
    }
  }, [_c('form', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length !== 0),
      expression: "leakageLog.length!==0"
    }]
  }, [_vm._v(_vm._s(_vm.$t("watersystem.detection-history")))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length === 0),
      expression: "leakageLog.length===0"
    }]
  }, [_vm._v(_vm._s(_vm.$t('watersystem.no-water-leak-history')))]), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-5 pr-5",
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "type": "button",
      "disabled": _vm.reloading || _vm.autoReload
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("chart.button-reload")) + "\n        ")])], 1)], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leakageLog.length !== 0),
      expression: "leakageLog.length!==0"
    }],
    staticClass: "mt-3 leakage-log-table"
  }, _vm._l((_vm.leakageLog), function(log) {
    return _c('tr', {
      class: _vm.getClassName(log.state)
    }, [(log.state == 1) ? _c('td', [_vm._v(_vm._s(_vm.$t('watersystem.leakage-alert')))]) : _vm._e(), _vm._v(" "), (log.state == 0) ? _c('td', [_vm._v(_vm._s(_vm.$t('watersystem.return-to-normal')))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.timestamp))])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-27749305","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeakageLog.vue
// module id = 1914
// module chunks = 0